import React, { useEffect, useState } from "react";
import { Info } from "lucide-react";
import HoverTip from "./HoverTip";
import { getDataSource, setDataSource } from "@/lib/dataSource";
import { getDataSourceStatus } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const TIP = `Fuente de datos de prueba para el Ratio Compra/Venta (POC/POV) y su histórico, en todas las páginas a la vez: ficha, Comparar, Cartera (Nivel 1), Watchlist (Nivel 2), Visual e ideas de la comunidad. Compáralas y decide cuál es mejor. En la ficha, los ingresos y el FCF a 2 años se pueden ver con horizonte TTM (desde los últimos 12 meses) o ANUAL (desde el último ejercicio cerrado), con la fuente elegida.

• GRATIS: cifras publicadas (ingresos, FCF, márgenes, deuda, acciones e histórico de ~15-20 años) de la SEC (EDGAR), para empresas de EE. UU. y extranjeras que cotizan allí; previsiones de analistas de Yahoo (yfinance); precio de Marketstack. Las empresas que no presentan en la SEC, o cuando a la SEC le falta el último trimestre, usan Yahoo para las cifras.

• NUESTRO: las mismas cifras publicadas de la SEC que Gratis, pero las proyecciones a 2 años las hace nuestro propio sistema, sin analistas: la guía que da la propia empresa en su comunicado de resultados (SEC), un modelo sobre su histórico (el crecimiento se frena hacia el largo plazo y el margen tiende a su mediana; si la empresa está en tus tesis, tu combinado cualitativo decide cuánto se frena) y un ajuste con IA a partir de hechos publicados en la web. Todo con datos públicos, sin restricciones de uso comercial.

Solo afecta a este navegador y solo lo ve el administrador (el resto de usuarios ve Nuestro). Al cambiar, la página se recarga para que todos los datos vengan de la fuente elegida.`;

export default function DataSourceToggle() {
    const { user } = useAuth();
    const [chosen] = useState(getDataSource);
    const [serverDefault, setServerDefault] = useState("own");
    // A test tool for the administrator only: the server says whether this session may
    // switch (and ignores the header for everyone else).
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        let alive = true;
        getDataSourceStatus()
            .then((s) => {
                if (!alive) return;
                setAllowed(!!s?.switch);
                if (s?.default) setServerDefault(s.default);
            })
            .catch(() => { if (alive) setAllowed(false); });
        return () => { alive = false; };
    }, [user?.email]);

    if (!allowed) return null;
    // Nothing chosen in this browser: the server's default is the one in use.
    const source = chosen || serverDefault;

    const choose = (v) => {
        if (v === source) return;
        setDataSource(v);
        window.location.reload();
    };

    const seg = (v, label) => (
        <button
            type="button"
            onClick={() => choose(v)}
            aria-pressed={source === v}
            className={`px-2 sm:px-2.5 py-2 font-mono text-[11px] uppercase tracking-wider transition-colors ${
                source === v ? "bg-[#052049] text-white" : "bg-white text-[#4A4A4A] hover:bg-[#F5E4D4]"
            }`}
            data-testid={`data-source-${v}`}
        >
            {label}
        </button>
    );

    return (
        <div className="flex items-center gap-1.5 shrink-0" data-testid="data-source-toggle">
            <div className="flex items-stretch border border-black divide-x divide-black" role="group" aria-label="Fuente de datos">
                {seg("free", "Gratis")}
                {seg("own", "Nuestro")}
            </div>
            <HoverTip text={TIP} maxWidth={360}>
                <button type="button" className="text-[#9A9A9A] hover:text-[#052049] relative" aria-label="Qué es la fuente de datos" data-testid="data-source-info">
                    <Info size={15} />
                </button>
            </HoverTip>
        </div>
    );
}
